import ConfirmationModalModule, { ConfirmationModalType} from "./confirmationModal-module";

export {ConfirmationModalModule, ConfirmationModalType};



// WEBPACK FOOTER //
// ./lib/ts/modules/confirmationModal/index.ts